<script setup>
import { computed, inject } from 'vue';
import SuggestionList from '@/components/result/SuggestionList.vue';
import HelperResources from '@/components/result/HelperResources.vue'; 

// 부모에서 주입받은 데이터
const classData = inject('classData');
const loading = inject('loading');

const region = "seoul";

// 학교급과 학년에 따른 gradeLevel 설정
const gradeLevel = computed(() => {
    if (!classData.value) return 'E_4';
    
    const schoolType = classData.value.schul_type;
    const grade = parseInt(classData.value.grade_code);
    
    if (schoolType === 'E') {
        return grade === 4 ? 'E_4' : 'E_6';
    } else if (schoolType === 'M') {
        return 'M_2';
    } else if (schoolType === 'H') {
        return 'H_1';
    }
    
    return 'E_4'; // 기본값
});

// gradeGroup 설정 (초등학교 vs 중고등학교)
const gradeGroup = computed(() => {
    if (!classData.value) return 'elementary';
    
    const schoolType = classData.value.schul_type;
    
    if (schoolType === 'E') {
        return 'elementary';
    } else if (schoolType === 'M' || schoolType === 'H') {
        return 'secondary';
    }
    
    return 'elementary'; // 기본값
});

// 디버깅 로그
console.log('Teacher Page7: SuggestionList 데이터:', {
    gradeLevel: gradeLevel.value,
    gradeGroup: gradeGroup.value,
    schoolType: classData.value?.schul_type,
    grade: classData.value?.grade_code
});
</script>

<template>
    <div class="slide-inner">
        <div class="content pt-[30px]">
            <SuggestionList 
                type="literacy" 
                :region="region" 
                :gradeGroup="gradeGroup"
                :gradeLevel="gradeLevel"
                :isStudent="false"
            />
            <SuggestionList 
                type="numeracy" 
                :region="region" 
                :gradeGroup="gradeGroup"
                :gradeLevel="gradeLevel"
                :isStudent="false"
                :class="{ 'pt-5 pb-6': gradeGroup === 'elementary' }"
            />
            <div class="bg-gary">
                <n-flex :wrap="false" justify="space-between" align="center" class="pt-5"> 
                    <HelperResources /> 
                    <div class="img-wrap">
                        <img src="@/assets/images/result/qr_small.png">
                    </div>                    
                </n-flex>                
            </div>
        </div>
    </div>
</template>

<style  lang="scss" scoped>
.bg-gary {
    position: relative;
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -50px;
        width: calc(100% + 100px);
        z-index: -1;
        padding: 0 50px;
        background-color:#FAFAFA;
        height: calc(100% + 20px);
        min-height: 400px;
        border-bottom-right-radius: 30px;
        border-bottom-left-radius: 30px;
    }
    .img-wrap {
        width: calc(100% - 660px);
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 7.5%;
    }
}
</style>
